import styled, { css } from 'styled-components'

export const Wrapper = styled.div<{ noMargin: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: ${({ theme }) => theme.color.background.neutral.weak};
  padding: ${({ theme }) => theme.spacing.km3};
  border-radius: ${({ theme }) => theme.border.radius.xlarge};
  margin-top: ${({ theme }) => theme.spacing.km6};

  @media (max-width: ${({ theme }) => theme.breakpoint.lg.minWidth}) {
    ${({ noMargin }) =>
      !noMargin &&
      css`
        margin: ${({ theme }) => theme.spacing.km6} ${({ theme }) => theme.spacing.km0};
      `};
  }
`

export const PageDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.km6};
`

export const CurrentPageWrapper = styled(PageDetailsWrapper)`
  fuel-button::part(button) {
    height: ${({ theme }) => theme.spacing.km10};

    color: ${({ theme }) => theme.color.background.neutral.inverted};
  }
`

export const ArrowsActionsWrapper = styled(PageDetailsWrapper)`
  gap: ${({ theme }) => theme.spacing.km3};

  fuel-button::part(button) {
    height: ${({ theme }) => theme.spacing.km10};
    min-width: ${({ theme }) => theme.spacing.km10};
    width: ${({ theme }) => theme.spacing.km10};
  }
`

export const ListPaginationWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.km2};
  overflow-y: auto;
  width: 150px;
  height: 100px;
`

export const Item = styled.div`
  cursor: pointer;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.km2};
`
